export default __webpack_public_path__ + "static/media/faw.7b1720fa.jpeg";